import { useInstanceApi } from '../../../api/axios';
import { GridDataState, useRequest } from '../../../utils/request';

const URL = {
  fetchInvoiceList: 'cf/factures',
  fetchInvoiceListExport: 'cf/export',
};

function useInvoiceListApi() {
  const instance = useInstanceApi();

  const { request: fetchInvoiceList } = useRequest((queryParams: GridDataState & { id_coll: number }) =>
    instance.get(URL.fetchInvoiceList, {
      params: {
        id_coll: queryParams.id_coll,
        p: queryParams.currentPage,
        ipp: queryParams.itemPerPage,
        'order[dir]': queryParams.order?.dir,
        'order[column]': queryParams.order?.column,
        ...queryParams.filters,
      },
    })
  );

  const { request: fetchInvoiceListExport } = useRequest(
    ({ csvName, ...queryParams }: { id_coll: number; token?: string | null; csvName: string }) =>
      instance.get(URL.fetchInvoiceListExport, {
        params: {
          t: 'f',
          ...queryParams,
        },
        headers: {
          'Content-Type': 'application/csv',
          'Content-Disposition': `attachment; filename=${csvName}`,
        },
      })
  );

  return {
    fetchInvoiceList,
    fetchInvoiceListExport,
  };
}

export default useInvoiceListApi;
